<template>
  <div class="loading">
    <i class="fas fa-cog"></i>
  </div>
</template>

<style lang="scss">
@use "@/scss/items/loading/loading";
</style>
